import { connect } from 'react-redux';
import { UploadDocumentComponent } from './upload-document.component';
import { uploadDocument } from 'shared/store/actions/knowledge.items.actions';

const mapStateToProps = () => ({});

export const UploadDocument = connect(mapStateToProps, { uploadDocument })(UploadDocumentComponent);
